export enum BetaFeatureAcceptanceStatus {
  CONFIRMED = 'CONFIRMED',
  DECLINED = 'DECLINED',
}
